import { useEffect, useState } from "react";
import { blcContactPageData } from "../../Blc_Api/BlcContactPageData/BlcContactPageData";







export function useContactPageData() {
    const [contactData,setContactData] = useState();

    useEffect(()=>{
       blcContactPageData().then(response=>{
            setContactData(response);
        })
    },[]);

    return [contactData,setContactData]
}